function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2 24H2.4C1.07452 24 0 22.9255 0 21.6V4.8C0 3.47452 1.07452 2.4 2.4 2.4H4.8V0H7.2V2.4H14.4V0H16.8V2.4H19.2C20.5255 2.4 21.6 3.47452 21.6 4.8V21.6C21.6 22.9255 20.5255 24 19.2 24ZM2.4 9.6V21.6H19.2V9.6H2.4ZM2.4 4.8V7.2H19.2V4.8H2.4ZM16.8 19.2H14.4V16.8H16.8V19.2ZM12 19.2H9.6V16.8H12V19.2ZM7.2 19.2H4.8V16.8H7.2V19.2ZM16.8 14.4H14.4V12H16.8V14.4ZM12 14.4H9.6V12H12V14.4ZM7.2 14.4H4.8V12H7.2V14.4Z",
  fill: "#2B2B2B"
});

function SvgReserveSpot(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserveSpot);
export default __webpack_public_path__ + "static/media/reserve-spot.33c6479e.svg";
export { ForwardRef as ReactComponent };